import Axios from 'axios'

export default {
  state: {
    template: null,
    templates: []
  },
  getters: {
    TEMPLATE: state => state.template
  },
  mutations: {
    ADD_TEMPLATE (state, payload) {
      state.templates.push( payload )
    },
    SET_TEMPLATE ( state, template ) {
      state.template = template;
    },
  },
  actions: {
    ADD_TEMPLATE: async ( context, params ) => {
      let { data } = await Axios.post( '/email-templates', params );
      context.commit('ADD_TEMPLATE', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_TEMPLATE ( { commit }, template ) {
      commit( 'SET_TEMPLATE', template );
    },
    GET_TEMPLATE: async ( context, templateId ) => {
      context.commit('SET_TEMPLATE', false);
      let { data } = await Axios.get( '/email-templates/' + templateId )
      context.commit('SET_TEMPLATE', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    }
  },
}
